import { TFunction } from 'i18next';

export const dialogCommonOptions = (t: TFunction) => ({
  title: t('pages:errorBoundary.dialog.title'),
  subtitle: t('pages:errorBoundary.dialog.subtitle'),
  subtitle2: t('pages:errorBoundary.dialog.subtitle2'),
  labelName: t('pages:errorBoundary.dialog.labelName'),
  labelEmail: t('pages:errorBoundary.dialog.labelEmail'),
  labelComments: t('pages:errorBoundary.dialog.labelComments'),
  labelClose: t('pages:errorBoundary.dialog.labelClose'),
  labelSubmit: t('pages:errorBoundary.dialog.labelSubmit'),
  errorGeneric: t('pages:errorBoundary.dialog.errorGeneric'),
  errorFormEntry: t('pages:errorBoundary.dialog.errorFormEntry'),
  successMessage: t('pages:errorBoundary.dialog.successMessage'),
});
